module.exports = __webpack_public_path__ + "static/media/icone-sumula.59ca6f67.svg";